/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";
import type { CompanyDocumentDataFromHubble } from "./CompanyDocumentDataFromHubble";
import {
  CompanyDocumentDataFromHubbleFromJSON,
  CompanyDocumentDataFromHubbleFromJSONTyped,
  CompanyDocumentDataFromHubbleToJSON,
  CompanyDocumentDataFromHubbleToJSONTyped,
} from "./CompanyDocumentDataFromHubble";

/**
 *
 * @export
 * @interface ActivateCustomerSpecificPricingAgreementRequest
 */
export interface ActivateCustomerSpecificPricingAgreementRequest {
  /**
   *
   * @type {CustomerSpecificPricingAgreement}
   * @memberof ActivateCustomerSpecificPricingAgreementRequest
   */
  agreement: CustomerSpecificPricingAgreement;
  /**
   *
   * @type {Array<CompanyDocumentDataFromHubble>}
   * @memberof ActivateCustomerSpecificPricingAgreementRequest
   */
  documents: Array<CompanyDocumentDataFromHubble>;
}

/**
 * Check if a given object implements the ActivateCustomerSpecificPricingAgreementRequest interface.
 */
export function instanceOfActivateCustomerSpecificPricingAgreementRequest(
  value: object,
): value is ActivateCustomerSpecificPricingAgreementRequest {
  if (!("agreement" in value) || value["agreement"] === undefined) return false;
  if (!("documents" in value) || value["documents"] === undefined) return false;
  return true;
}

export function ActivateCustomerSpecificPricingAgreementRequestFromJSON(
  json: any,
): ActivateCustomerSpecificPricingAgreementRequest {
  return ActivateCustomerSpecificPricingAgreementRequestFromJSONTyped(
    json,
    false,
  );
}

export function ActivateCustomerSpecificPricingAgreementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivateCustomerSpecificPricingAgreementRequest {
  if (json == null) {
    return json;
  }
  return {
    agreement: CustomerSpecificPricingAgreementFromJSON(json["agreement"]),
    documents: (json["documents"] as Array<any>).map(
      CompanyDocumentDataFromHubbleFromJSON,
    ),
  };
}

export function ActivateCustomerSpecificPricingAgreementRequestToJSON(
  json: any,
): ActivateCustomerSpecificPricingAgreementRequest {
  return ActivateCustomerSpecificPricingAgreementRequestToJSONTyped(
    json,
    false,
  );
}

export function ActivateCustomerSpecificPricingAgreementRequestToJSONTyped(
  value?: ActivateCustomerSpecificPricingAgreementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreement: CustomerSpecificPricingAgreementToJSON(value["agreement"]),
    documents: (value["documents"] as Array<any>).map(
      CompanyDocumentDataFromHubbleToJSON,
    ),
  };
}
